var _g, _defs, _defs2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWorldNewsWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.3175 8.73885C17.5282 3.86148 15.6665 0.436951 13.5 0.436951C11.3335 0.436951 9.47177 3.86148 8.68246 8.73885H18.3175ZM8.27419 13.9822C8.27419 15.1947 8.33952 16.358 8.45383 17.4777H18.5407C18.655 16.358 18.7204 15.1947 18.7204 13.9822C18.7204 12.7696 18.655 11.6063 18.5407 10.4866H8.45383C8.33952 11.6063 8.27419 12.7696 8.27419 13.9822ZM25.9494 8.73885C24.3925 5.0303 21.2407 2.16287 17.3486 1.00498C18.6768 2.85105 19.5913 5.6311 20.0704 8.73885H25.9494ZM9.64597 1.00498C5.75927 2.16287 2.60202 5.0303 1.0506 8.73885H6.92964C7.40323 5.6311 8.31774 2.85105 9.64597 1.00498ZM26.5319 10.4866H20.2881C20.4024 11.6336 20.4677 12.8079 20.4677 13.9822C20.4677 15.1564 20.4024 16.3307 20.2881 17.4777H26.5264C26.8258 16.358 26.9946 15.1947 26.9946 13.9822C26.9946 12.7696 26.8258 11.6063 26.5319 10.4866ZM6.53226 13.9822C6.53226 12.8079 6.59758 11.6336 6.7119 10.4866H0.468145C0.174194 11.6063 0 12.7696 0 13.9822C0 15.1947 0.174194 16.358 0.468145 17.4777H6.70645C6.59758 16.3307 6.53226 15.1564 6.53226 13.9822ZM8.68246 19.2255C9.47177 24.1028 11.3335 27.5274 13.5 27.5274C15.6665 27.5274 17.5282 24.1028 18.3175 19.2255H8.68246ZM17.354 26.9593C21.2407 25.8014 24.398 22.934 25.9548 19.2255H20.0758C19.5968 22.3332 18.6823 25.1132 17.354 26.9593ZM1.0506 19.2255C2.60746 22.934 5.75927 25.8014 9.65141 26.9593C8.32319 25.1132 7.40867 22.3332 6.92964 19.2255H1.0506Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5236_70531"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27.9643,
    fill: "white"
  })))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient_paint",
    x1: 1.66487e-8,
    y1: 14.4482,
    x2: 26.9946,
    y2: 14.4482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E85EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DD9FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorldNewsWhite);
export default __webpack_public_path__ + "static/media/world_news_white.31ac45c6335c3fa1128c775e279116f4.svg";
export { ForwardRef as ReactComponent };